// extracted by mini-css-extract-plugin
export default {"box":"checkbox_box__vBD83","checkbox":"checkbox_checkbox__4KTAl"};